import { render, staticRenderFns } from "./RiskDebtFixedInput.vue?vue&type=template&id=4057ab67&scoped=true"
import script from "./RiskDebtFixedInput.vue?vue&type=script&lang=js"
export * from "./RiskDebtFixedInput.vue?vue&type=script&lang=js"
import style0 from "./RiskDebtFixedInput.vue?vue&type=style&index=0&id=4057ab67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4057ab67",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCardActions,VIcon,VSimpleTable,VTextField})
